import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from '@app/shared/components';
import { PartNumber } from '@models/partNumber.model';
import { PartNumberEquivalent } from '@models/partNumberEquivalent.model';
import { cloneDeep } from 'lodash';

@Component({
    selector: 'app-strain-equivalent-part-numbers-modal',
    templateUrl: './strain-equivalent-part-numbers-modal.component.html',
    styleUrls: ['./strain-equivalent-part-numbers-modal.component.scss']
})
export class StrainEquivalentPartNumbersModalComponent {
    @ViewChild(ModalComponent, { static: false }) modal: ModalComponent;

    @Input() partNumbers: PartNumber[] = [];
    @Input() selectedPartNumber: PartNumber;
    @Input() equivalentPartNumbers: PartNumberEquivalent[] = [];
    @Input() isUpdateInProgress = false;

    @Output() save = new EventEmitter<number[]>();

    selectedEquivalentPartNumbers: PartNumberEquivalent[] = [];

    open(event?: MouseEvent): void {
        event?.stopPropagation();
        this.selectedEquivalentPartNumbers = cloneDeep(this.equivalentPartNumbers || []);
        this.modal?.open();
    }

    close(): void {
        this.modal?.close();
    }

    onSelectionChange(target: any[]): void {
        this.selectedEquivalentPartNumbers = cloneDeep(target || []) as PartNumberEquivalent[];
    }

    onSave(): void {
        const equivalentPartNumberIds = (this.selectedEquivalentPartNumbers || []).map(item => item.id);
        this.save.emit(equivalentPartNumberIds);
        this.close();
    }

    get availableEquivalentPartNumbers(): PartNumber[] {
        const currentPartNumberId = this.selectedPartNumber?.id;
        return (this.partNumbers || []).filter(item => item.id !== currentPartNumberId);
    }
}
